<template>
  <div class="bem-vindo bg-primary fill-height overflow-hidden">
    <v-layout align-center justify-center fill-height>
      <v-row no-gutters>
        <v-col cols="12">
          <v-fade-transition :key="statusLoading" hide-on-leave mode="out-in">
            <div v-if="statusLoading === 1">
              <v-card
                :rounded="false"
                class="d-flex justify-center flex-column"
              >
                <v-card-text>
                  <v-row no-gutters class="d-flex justify-center text-center">
                    <v-col cols="12" class="d-flex justify-center my-3">
                      <div class="d-flex flex-column align-center">
                        <v-progress-circular class="mb-3" indeterminate />
                        <div v-if="statusLoading === 1" class="mt-2">
                          <span>{{ $t("validando_qrcode") }}</span>
                          <div class="my-2">
                            <v-icon size="60" class="ma-0">mdi-qrcode</v-icon>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
          </v-fade-transition>
          <v-fade-transition :key="statusLoading" leave-absolute>
            <div v-if="[0, 2, 3].includes(statusLoading)">
              <v-card
                :rounded="false"
                class="d-flex justify-center flex-column"
              >
                <v-card-text>
                  <v-row no-gutters class="d-flex justify-center text-center">
                    <v-col
                      cols="12"
                      class="d-flex flex-column align-center justify-center"
                    >
                      <v-fade-transition>
                        <div>
                          <h1 class="body-1 mb-6">
                            {{ $t("bem_vindo_exclamacao") }}
                          </h1>
                          <v-img
                            contain
                            content-class="d-flex"
                            :src="clientLogo() || $store.state.imgLogoDefault"
                            max-width="180"
                          />
                        </div>
                      </v-fade-transition>
                    </v-col>
                    <v-col
                      v-if="!qrCodeError && cliente.imgLogo"
                      cols="5"
                      class="pa-2 pb-3 pt-6"
                    >
                      <v-divider v-if="cliente.imgLogo" />
                    </v-col>
                    <v-col cols="12">
                      <v-fade-transition leave-absolute>
                        <div v-if="!qrCodeError" class="mt-6">
                          <div class="d-flex flex-column align-center">
                            <v-progress-circular
                              v-if="!isChooseOption"
                              class="mb-3"
                              indeterminate
                            />
                            <div
                              class="mt-2 d-flex flex-column"
                              :class="
                                isChooseOption
                                  ? 'align-center justify-center'
                                  : 'align-start justify-start'
                              "
                            >
                              <div class="my-2">
                                <v-icon size="18" color="success" class="mb-1">
                                  mdi-check-circle
                                </v-icon>
                                <span>
                                  {{ $t("qrcode_verificado_sucesso") }}
                                </span>
                              </div>

                              <div
                                v-if="isChooseOption && statusLoading === 0"
                                class="d-flex flex-column"
                              >
                                <span class="my-6">{{
                                  $t("escolha_uma_opcao")
                                }}</span>
                                <v-btn
                                  min-width="100%"
                                  dark
                                  color="grey darken-3"
                                  @click="onToCadastro(null)"
                                >
                                  {{ $t("Novo_Cadastro") }}
                                </v-btn>
                                <v-btn
                                  x-small
                                  class="mt-4 py-5"
                                  @click="onToCadastro($route.params.id)"
                                >
                                  <span
                                    style="
                                      padding: 0.2rem 0 0;
                                      white-space: normal;
                                      max-width: 260px;
                                    "
                                  >
                                    {{ $t("ja_sou_cadastrado") }}
                                    {{
                                      $route.path.includes("pet")
                                        ? $t("um_pingente")
                                        : $route.path.includes("id")
                                        ? $t("um_bracelete")
                                        : $route.path.includes("tag")
                                        ? $t("um_tag")
                                        : ""
                                    }}
                                  </span>
                                </v-btn>
                              </div>
                              <div v-else>
                                <v-icon size="17" class="mb-1">
                                  mdi-open-in-new
                                </v-icon>
                                {{ $t("redirecionando_painel") }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div
                            style="
                              position: relative;
                              display: table;
                              margin: 0 auto;
                            "
                          >
                            <v-icon
                              color="warning"
                              size="25"
                              style="
                                position: absolute;
                                bottom: 0;
                                right: -9px;
                                z-index: 3;
                              "
                              >mdi-alert</v-icon
                            >
                            <v-icon size="45">mdi-qrcode</v-icon>
                          </div>
                          <h3 class="subtitle-2 mt-2">
                            {{ $t("qrcode_nao_encontrado") }}
                          </h3>
                        </div>
                      </v-fade-transition>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-layout>
  </div>
</template>

<script>
import i18next from "i18next";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("bem_vindo_exclamacao") || "") + " | %s",
  },
  data: () => ({
    qrCodeError: false,
    isChooseOption: false,
    logo: "",
  }),
  mounted() {
    const localLang = navigator.language.toLowerCase().replace("-", "_");

    if (
      !this.$store.state.language &&
      this.$store.state.languages.some((e) => e.flag === localLang)
    ) {
      this.$store.commit("setLanguage", localLang);
    } else if (!this.$store.state.language) {
      this.$store.commit("setLanguage", "en");
    }

    // reseta o cliente
    this.$store.commit("cliente/setData", {});

    if (this.$route.path.includes("pet")) {
      this.$store.dispatch("pet/checkIn", {
        uid: this.$route.path.substr(1),
        callbackSuccess: (res) => {
          // seta o cliente vinculado com o qrcode
          this.$store.commit(
            "cliente/setData",
            res.data.content ? res.data.content.cliente : {}
          );

          // se token for null quer dizer que o qrcode já possui cadastro de usuário
          // e direciona para home
          if (res.data.content.token === null) {
            setTimeout(this.onToHome, 4000);

            // se token não for null quer dizer que foi gerado uma sessão para
            // o usuario cadastrar o qrcode e direciona para o cadastro
          } else {
            this.isChooseOption = true;
          }
        },
        callbackError: (err) => {
          if (err.response.status === 401) return this.$router.push("/login");
          this.qrCodeError = true;
        },
      });
    } else if (this.$route.path.includes("tag")) {
      this.$store.dispatch("tag/checkIn", {
        uid: this.$route.path.substr(1),
        callbackSuccess: (res) => {
          // seta o cliente vinculado com o qrcode
          this.$store.commit(
            "cliente/setData",
            res.data.content ? res.data.content.cliente : {}
          );

          if (res.data.content.token === null) {
            setTimeout(this.onToHome, 4000);
          } else {
            this.isChooseOption = true;
          }
        },
        callbackError: (err) => {
          if (err.response.status === 401) return this.$router.push("/login");
          this.qrCodeError = true;
        },
      });
    } else {
      this.$store.dispatch("pessoa/checkIn", {
        uid: this.$route.path.substr(1),
        callbackSuccess: (res) => {
          // seta o cliente vinculado com o qrcode
          this.$store.commit(
            "cliente/setData",
            res.data.content ? res.data.content.cliente : {}
          );

          if (res.data.content.token === null) {
            setTimeout(this.onToHome, 4000);
          } else {
            this.isChooseOption = true;
          }
        },
        callbackError: (err) => {
          if (err.response.status === 401) return this.$router.push("/login");
          this.qrCodeError = true;
        },
      });
    }
  },
  computed: {
    pessoa() {
      return this.$store.state.pessoa;
    },
    pet() {
      return this.$store.state.pet;
    },
    tag() {
      return this.$store.state.tag;
    },
    cliente() {
      return this.$store.state.cliente.data || {};
    },
    clientLogo() {
      return () => {
        if (this.cliente.imgLogo) {
          const prefs = JSON.parse(this.cliente.opcoes);

          const logo = prefs?.all.welcome.logo.image;

          this.logo = !logo ? null : this.cliente.imgLogo + "/" + logo + ".jpg";

          return this.logo;
        } else {
          return this.logo;
        }
      };
    },
    statusLoading() {
      if (this.$route.path.includes("pet")) {
        return this.pet.status;
      } else if (this.$route.path.includes("tag")) {
        return this.tag.status;
      } else {
        return this.pessoa.status;
      }
    },
  },
  methods: {
    onToCadastro(id = null) {
      this.$store.dispatch("auth/logout");

      if (this.$route.path.includes("pet")) {
        this.$store.commit("pet/setUID", "app/pet/" + this.$route.params.id);
        this.$store.commit("setContext", "pet");
      } else if (this.$route.path.includes("tag")) {
        this.$store.commit(
          "tagFuncionario/setUID",
          "app/tag/" + this.$route.params.id
        );
        this.$store.commit("tag/setUID", "app/tag/" + this.$route.params.id);
        this.$store.commit("setContext", "tagFuncionario");
      } else {
        this.$store.commit("setContext", "pessoa");
        this.$store.commit("pessoa/setUID", "app/id/" + this.$route.params.id);
      }
      this.$router.push({
        path: !id ? "/sign-up" : "/sign-up?id=" + id,
      });
    },
    onToHome() {
      this.$store.dispatch("auth/logout");

      if (this.$route.path.includes("pet")) {
        this.$store.commit("pet/setUID", "app/pet/" + this.$route.params.id);
        this.$store.commit("setContext", "pet");
        this.$router.push("/pet");
      } else if (this.$route.path.includes("tag")) {
        this.$store.commit(
          "tagFuncionario/setUID",
          "app/tag/" + this.$route.params.id
        );
        this.$store.commit("tag/setUID", "app/tag/" + this.$route.params.id);
        this.$store.commit("setContext", "tagFuncionario");
        this.$router.push("/tag");
      } else {
        this.$store.commit("setContext", "pessoa");
        this.$store.commit("pessoa/setUID", "app/id/" + this.$route.params.id);
        this.$router.push("/");
      }
    },
  },
};
</script>

<style lang="scss">
.bem-vindo {
  > .layout > .row {
    max-width: 300px;
  }
  .v-card {
    min-height: 400px;
  }
}
</style>
